import React from "react"
import { Center, IconButtonProps as ChakraIconButtonProps } from "@chakra-ui/react"
import { IconButton as ChakraIconButton } from "@chakra-ui/react"
import { IconButtonContent } from "../types/button-content"
import { Tooltip } from "@hydrologiq/shared/chakra/Tooltip"

export type IconButtonProps = ChakraIconButtonProps & { context?: IconButtonContent; description?: string }

export const IconButton = (props: IconButtonProps) => {
  const description = props.description || props.context?.description
  return (
    <Center>
      <Tooltip disabled={props.disabled} content={description}>
        <ChakraIconButton
          variant={
            props.context?.variant === "primary"
              ? "hydrologiq_primary"
              : props.context?.variant === "secondary"
              ? "hydrologiq_secondary"
              : "hydrologiq_icon"
          }
          size={props.size || "xs"}
          aria-label={props["aria-label"] || description}
          data-testid={`button-${props.context?.label}`}
          {...props}
        >
          {props.context?.icon && React.createElement(props.context.icon)}
        </ChakraIconButton>
      </Tooltip>
    </Center>
  )
}
